import { watch, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useCourseStore } from '@/stores/courseStore';

const MODE_QUERY_ROUTE_PREFIXES = [
  '/app/calculate',
  '/app/structure-model-selection',
];

function routeHasModeQuery(path) {
  if (!path) return false;
  // Страница выбора модуля: ?mode= не должен перезаписывать модуль из контекста курса.
  if (path === '/app/calculate' || path === '/app/calculate/') {
    return false;
  }
  return MODE_QUERY_ROUTE_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`) || path.startsWith(prefix)
  );
}

/**
 * Синхронизирует activeCalculationModuleId в courseStore с ?mode= в маршруте расчёта.
 */
export function useActiveCalculationModule() {
  const route = useRoute();
  const courseStore = useCourseStore();

  function syncFromRoute() {
    const modeId = route.query?.mode;
    if (!modeId || typeof modeId !== 'string') return;
    if (!routeHasModeQuery(route.path)) return;
    courseStore.setActiveCalculationModule(modeId);
  }

  onMounted(syncFromRoute);
  watch(
    () => [route.path, route.query?.mode],
    () => syncFromRoute()
  );
}
